import api from '@/api/index.js'

const account_payment_cards = {
  state: {
    loading: false,
    data: [],
    error: null
  },

  mutations: {
    SET_ACCOUNT_PAYMENT_CARDS_LOADING: (state, loading) => {
      state.loading = loading;
    },
    SET_PAYMENT_CARDS: (state, response) => {
      state.data = response;
      state.loading = false;
    },
    SET_PAYMENT_CARDS_ERROR: (state, error) => {
      state.error = error;
      state.loading = false;
    }
  },

  actions: {
    LoadAccountPaymentCards({commit}, accountID) {
      commit('SET_PAYMENT_CARDS_ERROR', null)
      commit('SET_ACCOUNT_PAYMENT_CARDS_LOADING', true)
      return api.get(`accounts/${accountID}/payment-cards?limit=150&offset=0`)
        .then((response) => {
          commit('SET_PAYMENT_CARDS', response)
        })
        .catch((error) => {
          commit('SET_PAYMENT_CARDS_ERROR', error)
          commit('SET_ERROR', error.bodyText == '' ? error.url + ' - ' + error.status : error.bodyText)
        })
    }
  },
}

export default account_payment_cards
